import appCities from "../../views/appSettings/cities.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "cities";
  const params = ["page", "limit", "sort"];

  $stateProvider.state("cities", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCities,
      },
    },
    reloadOnSearch: false,
    data: { title: "Cities" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/cities/cities.urls.js